import axiosInstance from './axiosInstance';

export const forgotPassword = async (email: string) => {
    const response = await axiosInstance.post('/auth/forgot-password', { email });
    return response.data;
};

export const resetPassword = async (token: string, newPassword: string) => {
    const response = await axiosInstance.post('/auth/reset-password', {
        token,
        newPassword,
    });
    return response.data;
};

export const login = async (username: string, password: string) => {
    const response = await axiosInstance.post('/auth/login', {
        username,
        password,
    });
    return response.data;
};

interface RegisterData {
    email: string;
    password: string;
    username: string;
    team?: string | null;
    avatarUrl?: string | null;
}

export const register = async (userData: RegisterData) => {
    const response = await axiosInstance.post('/auth/register', userData);
    return response.data;
};

export const verifyEmail = async (token: string) => {
    const response = await axiosInstance.post('/auth/verify-email', { token });
    return response.data;
};

export const resendVerification = async (email: string) => {
    const response = await axiosInstance.post('/auth/resend-verification', { email });
    return response.data;
};